import React from 'react';
import classnames from 'classnames';
import Checkbox from 'material-ui/Checkbox';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import Loading from 'swag-client-common/components/info/loading';
import { getArticle } from 'swag-client-common/utils/get-article-by-colors.util';
import { PantoneColorPickerExtended } from '../../info/pantone-color-picker-extended';
import { MODES, HINTS } from './select-pantones-popup.constants';
import PreviewImage from './components/preview-image';
import Footer from './components/footer';
import classes from './select-pantones-popup.scss';
const paperClasses = {
  paper: classes.paperClass
};
const titleClasses = {
  root: classes.titleClass
};
const SelectPantonesPopup = ({
  preview,
  loading,
  isBackgroundRemoved,
  isRemoveBGCheckboxShown,
  variantColor,
  colors,
  productInfo,
  onContinueClick,
  onColorRemove,
  onColorAdd,
  onClose,
  onCancelClick,
  onRemoveBackgroundClick,
  isOneColorDetected,
  addColorEnabled,
  removeColorEnabled,
  mode,
  confirmText,
  cancelText,
  progressMessage,
  maxPrintColors,
  isDisabled,
  isErrorMessageShown
}) => {
  const isMobileView = isMobile();
  const isDesktopView = !isMobileView;
  const hasColors = colors && colors.length > 0;
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, loading && /*#__PURE__*/React.createElement(Loading, {
    hasOverlay: true,
    className: classes.loader
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.settingColumn, classes.column)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingsContentWrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, isOneColorDetected ? 'Here is the Pantone color our system detected' : 'Here are the Pantone colors our system detected'), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, HINTS[mode]), productInfo && /*#__PURE__*/React.createElement("div", {
    className: classes.productInfoBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Confirming colors for product"), /*#__PURE__*/React.createElement("div", {
    className: classes.productInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imgWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: productInfo.mockup,
    alt: "mockup"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.name
  }, productInfo.name))), isMobileView && /*#__PURE__*/React.createElement(PreviewImage, {
    preview: preview,
    variantColor: variantColor,
    progressMessage: progressMessage
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.numberOfColors
  }, "There ", colors.length > 1 ? 'are' : 'is', "\xA0", /*#__PURE__*/React.createElement("span", {
    className: classes.pinkLabel
  }, colors.length), "\xA0", colors.length > 1 ? 'colors' : 'color', " selected to print"), isErrorMessageShown && /*#__PURE__*/React.createElement("div", {
    className: classes.numberOfAllowedColors
  }, "This product allows only ", getArticle(maxPrintColors), "\xA0", /*#__PURE__*/React.createElement("u", null, /*#__PURE__*/React.createElement("b", null, maxPrintColors, "\xA0", maxPrintColors > 1 ? 'colors' : 'color')), "\xA0to print."), /*#__PURE__*/React.createElement(PantoneColorPickerExtended, {
    colors: colors,
    className: classes.pantoneColorPicker,
    addColorEnabled: addColorEnabled,
    removeColorEnabled: removeColorEnabled,
    onColorRemove: onColorRemove,
    onColorAdd: onColorAdd,
    hasColors: hasColors
  }), isRemoveBGCheckboxShown && !isDisabled && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    id: "removeBackgroundCheckbox",
    name: "Remove background",
    checked: isBackgroundRemoved,
    style: {
      width: '40px',
      float: 'left'
    },
    onCheck: onRemoveBackgroundClick
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "removeBackgroundCheckbox"
  }, "Remove background")), mode === MODES.PRODUCT_BUILDER && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.bottomDescription)
  }, "You can also do this later and input exact colors after you place your order. We are going to make sure your design comes out exactly how you want.")), !isDisabled && /*#__PURE__*/React.createElement(Footer, {
    confirmText: confirmText,
    cancelText: cancelText,
    hasColors: hasColors,
    onContinue: onContinueClick,
    onCancel: onCancelClick
  })), isDesktopView && /*#__PURE__*/React.createElement(PreviewImage, {
    preview: preview,
    variantColor: variantColor,
    progressMessage: progressMessage
  }));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "EditColorsPopup",
    content: content,
    open: true,
    onClose: onClose,
    popupClassName: classes.dialogClass,
    classes: paperClasses,
    titleClasses: titleClasses,
    closeClass: classes.closeClass,
    contentClass: classes.wrapper
  });
};
export default SelectPantonesPopup;